import { render, staticRenderFns } from "./inputList.vue?vue&type=template&id=5008e156&"
import script from "./inputList.vue?vue&type=script&lang=js&"
export * from "./inputList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports